import React from 'react';
import type { SVGProps } from 'react';
const SvgYoutube = (props : SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26 17"
    {...props}
  >
    <path
      fill={props?.fill || 'rgb(172, 185, 201)'}
      d="M24.572 2.654A3.03 3.03 0 0 0 22.438.507C20.558 0 13.012 0 13.012 0S5.466 0 3.585.507a3.03 3.03 0 0 0-2.133 2.147C.947 4.55.947 8.5.947 8.5s0 3.951.505 5.846a3.03 3.03 0 0 0 2.133 2.147C5.465 17 13.01 17 13.01 17s7.546 0 9.427-.507a3.03 3.03 0 0 0 2.134-2.147c.504-1.895.504-5.846.504-5.846s0-3.951-.505-5.846m-14.028 9.434V4.912L16.85 8.5z"
    />
  </svg>
);
export default SvgYoutube;
